import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'how_many_social_labor_audits_have_taken_place'

export const dataPointDefinition = {
  retracedId: 'how_many_social_labor_audits_have_taken_place',
  name: 'How many social / labor audits have taken place?',
  description:
    'Social / labor audit (or assessment) means any form of social / labor / CSR / ethical audit. Whether it was performed by a 3rd party organization or a brand/ customer. It does not include internal/ facility performed audits.',
  meta: {
    slcpMeta: {
      key: 'fp-oc-4',
      number: 'FP-CER-1',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'fp-oc-4', version: '1.7.0', provider: 'slcp'}],
  sortingId: 27910,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
